<template>
  <custom-dialog width="1200px" :title="model.title" :visible="visible" v-on="$listeners">
    <div class="dialog-body device-detail-log">
      <el-card class="box-card">
        <div slot="header" class="clearfix">
          <span>{{ $t('base_sys_content_dialog.qing_qiu_can_shu') }}</span>
        </div>
        <div class="text item">
          <pre>{{ JSON.stringify(requestParam, null, 2) }}</pre>
        </div>
      </el-card>
      <el-card style="margin-top:20px">
        <div slot="header" class="clearfix">
          <span>{{ $t('base_sys_content_dialog.ri_zhi_xin_xi') }}</span>
        </div>
        <!-- <custom-table
          index
          :data="routineDmList"
          @column="setColumn"
          @filter="filterChange"
          @sort="sortChange"
        ></custom-table> -->
        <ul class="info-box">
          <li v-for="(item, i) in routineDmList" :key="i" style="padding:4px 0">
            <el-row>
              <el-col style="width:160px">{{ item.gmtCreate }}</el-col>
              <el-col style="width:70px;color: #0D9AE0; padding-right:5px">{{ item.logLevel }}</el-col>
              <el-col style="width:200px;color: #0055f0;white-space:nowrap;overflow:hidden;text-overflow:ellipsis;" :title="item.funcName">{{ item.funcName }}</el-col>
              <el-col style="width:650px;padding-left:10px;line-height: 18px;" :title="item.logContent">{{ item.logContent }}</el-col>
            </el-row>
          </li>
        </ul>
      </el-card>
      <el-card class="box-card" style="margin-top:20px">
        <div slot="header" class="clearfix">
          <span>{{ $t('base_sys_content_dialog.xiang_ying_jie_guo') }}</span>
        </div>
        <div class="text item">
          <pre>{{ JSON.stringify(responseJson, null, 2) }}</pre>
        </div>
      </el-card>
      <el-card class="box-card" style="margin-top:20px" v-if="exceptionStr">
        <div slot="header" class="clearfix">
          <span>{{ $t('base_sys_content_dialog.cuo_wu_xiang_qing') }}</span>
        </div>
        <div class="text item">
          <pre>{{ exceptionStr }}</pre>
        </div>
      </el-card>
    </div>
    <div slot="footer" class="dialog-footer">
      <el-button @click="visible = false">{{ $t('Common.com_close') }}</el-button>
    </div>
  </custom-dialog>
</template>

<script>
import apis from '@/utils/apis';
import dialogMixins from '@/mixins/dialog_mixins';

export default {
  mixins: [dialogMixins],
  props: {
    data: [String, Object, Array],
    model: {
      type: Object,
      default() {
        return {
          type: '', // add、edit
          title: ''
        };
      }
    }
  },
  data() {
    return {
      requestNo: '',
      requestParam: {},
      routineDmList: [],
      responseJson: {},
      exceptionStr: ''
    };
  },
  mounted() {
    this.initDialog();
  },
  methods: {
    // 初始化
    initDialog: function () {
      if (this.model.type === 'see') {
        this.getlogInfo();
      }
    },
    // 获取消息推送模板树
    getlogInfo: function () {
      this.$getJSON(`${apis.LogInfo}?requestNo=${this.model.data.id}`).then((res) => {
        this.requestParam = res.data.interfaceDetailDm.requestParam;
        this.routineDmList = res.data.routineDmList;
        this.responseJson = res.data.interfaceDetailDm.responseResult;
        this.exceptionStr = res.data.interfaceDetailDm.exceptionStr || '';
      });
    }
  }
};
</script>

<style lang="scss">
.device-detail-log{
  pre{
    height: 200px;
    overflow: auto;
  }
}
</style>
